import React from 'react';

import StatsigRouteSwitch from './StatsigRouteSwitch';
import { featureGates } from '../../utils/statsig';
import config from '../../../config';

// The three growth-page route components (/join, /join/:sport, /referral/:code),
// extracted from the routes table so the param encoding and gate fallback are
// directly testable. Each factory takes the legacy component because routes.jsx
// owns withSuspense and the lazy imports.

export const buildJoinRoute = (LegacyComponent) => {
    const JoinRoute = (props) => (
        <StatsigRouteSwitch
            gate={featureGates.GROWTH_PAGES_NEXT_APP}
            enabledTo={`${config.nextAppHost}/join`}
            Component={LegacyComponent}
            routeProps={props}
        />
    );
    return JoinRoute;
};

export const buildJoinSportTypeRoute = (LegacyComponent) => {
    const JoinSportTypeRoute = (props) => {
        const { initiatingSportType } = props.match.params;
        return (
            <StatsigRouteSwitch
                gate={featureGates.GROWTH_PAGES_NEXT_APP}
                enabledTo={`${config.nextAppHost}/join/${encodeURIComponent(initiatingSportType)}`}
                Component={LegacyComponent}
                routeProps={props}
            />
        );
    };
    return JoinSportTypeRoute;
};

export const buildReferralRoute = (LegacyComponent) => {
    const ReferralRoute = (props) => {
        const { referralCode } = props.match.params;
        return (
            <StatsigRouteSwitch
                gate={featureGates.GROWTH_PAGES_NEXT_APP}
                enabledTo={`${config.nextAppHost}/referral/${encodeURIComponent(referralCode)}`}
                Component={LegacyComponent}
                routeProps={props}
            />
        );
    };
    return ReferralRoute;
};
